export const permissions = {
    READ: "INVOICE-READ",
    INVOICE_MANAGE_STUDENT: "INVOICE-MANAGE-STUDENT",
    ADHOC_ADDITIONAL_EDIT: "ADHOC-ADDITIONAL-EDIT",
    CREDITNOTE_CREATE: "CREDITNOTE-CREATE",
    UPLOAD_DOCUMENT_READ: "INVOICE-DOCUMENT-UPLOAD-VIEW",
    UPLOAD_DOCUMENT_CREATE: "INVOICE-DOCUMENT-UPLOAD-CREATE",
    UPLOAD_DOCUMENT_DELETE: "INVOICE-DOCUMENT-UPLOAD-DELETE",
}

export const invoice_status = {
    PENDING: 'pending',
    CANCELLED: 'cancelled'
}

export const invoice_type = {
    AD_HOC: 'ad-hoc',
    ADDITIONAL: 'additional',
    SALES: 'sales'
}

export const list_types = {
    REPORT: 'report',
    OPERATION: 'operation',
}